// HomeRowGrid.js
// Desktop two-column row helper: `columns` is an array of { node, flex }
// where `node` may be null. Drops the null columns instead of reserving
// their flex share, so a card that renders null when empty (DueSoonList,
// SuggestedNextList, ToReviewList, ...) no longer leaves a blank gap
// beside its surviving sibling. Renders nothing when no column has a
// node, a single full-width column when one remains, and the given flex
// ratios when both remain.
// See docs/superpowers/specs/2026-09-16-home-redesign.md §6.
import React from "react";
import { View, StyleSheet } from "react-native";

import { HOME } from "../homeTheme";

const HomeRowGrid = ({ columns = [], style, testID }) => {
  const present = (columns || []).filter((column) => column && column.node);

  if (present.length === 0) return null;

  return (
    <View style={[styles.row, style]} testID={testID}>
      {present.map((column, index) => (
        <View
          key={index}
          style={present.length === 1 ? styles.full : { flex: column.flex ?? 1, minWidth: 0 }}
        >
          {column.node}
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  row: { flexDirection: "row", gap: HOME.gap },
  full: { flex: 1, minWidth: 0 },
});

export default HomeRowGrid;
